import React, { useState, useEffect } from "react";
import { getUserData } from "../../controllers/UsersController";
import "./ExcursionBox.css";
 
function ExcursionBox({ id, name, onClick, creator_id, is_active }) {
    const [isLoading, setIsLoading] = useState(true);
    const [creator, setCreator] = useState(null);

    useEffect(() => {
        getUserData(creator_id)
            .then((data) => {
                console.log("API Response:", data);
                setCreator(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
                setCreator(null);
                setIsLoading(false);
            });
    }
    , [creator_id]);
    if (isLoading) {
        return <p>Loading...</p>;
    }

    if (!creator) {
        return null;
    }

    return (
        <div className="excursion-card" onClick={onClick} style={{ cursor: "pointer", border: "1px solid black", padding: "10px", margin: "5px" }}>
            <h3>{name}</h3>
            <p>Créateur : {creator.username}</p>
            <p>Active : {is_active ? "Oui" : "Non"}</p>
        </div>
    );
}

export default ExcursionBox;